module.exports = __webpack_public_path__ + "img/planti-logo.cc9bcd3f.svg";